module.exports = __webpack_public_path__ + "img/pintec1.364f1107.png";